export default {
  BusinessReportStockOut: {
    querySpu: 'Product name/code/code',
    stockoutOrderQty: 'Out of stock order count',
    stockoutGoodsQty: 'Out of stock item count',
    usableQty: 'Quantity available for transfer'
  }
};
